module.exports = __webpack_public_path__ + "static/media/phoneCardHeader.80376c0a.svg";